import { Alert } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';

const StyledBaseAlert = styled(Alert)`
  width: 100%;

  .ant-alert-message {
    font-size: 16px;
    line-height: 22px;
  }
`;

/**
 * Primary UI component for user interaction
 */
const AntdAlert = ({
  type,
  closable = false,
  message,
  description,
  showIcon = true,
  icon,
  banner,
}) => {
  return (
    <StyledBaseAlert
      type={type}
      message={message}
      description={description}
      closable={closable}
      showIcon={showIcon}
      icon={icon}
      banner={banner}
    />
  );
};

AntdAlert.propTypes = {
  /**
   * Alert contents
   */
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  message: PropTypes.string,
  description: PropTypes.node,
  closable: PropTypes.bool,
  showIcon: PropTypes.bool,
};

AntdAlert.defaultProps = {
  type: 'info',
  closable: true,
  showIcon: true,
  banner: false,
};

export { AntdAlert };
